//Payload Code
export const SUCCESS_CODE = 200;
export const SUCCESS_CREATED = 201;
export const SUCCESS_NO_CONTENT = 204;
export const NOT_VALID = 400;
export const NOT_AUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const CONFLICT = 409;
export const ERROR = 500;
export const TIMEOUT = 504;

//Payload Message
export const BAD_CREDENTIALS = "BAD_CREDENTIALS";
export const SUCCESS = "success";
export const AUTH_ERROR = "auth_error";
export const ERROR_SERVER_NOT_RESPONDING = "server_not_responding_error";
export const EMAIL_NOT_VALIDATED = "email_not_validated";

export const USER_DATA_ERROR_INVALID_ANONYMOUS_TOKEN = "USER_DATA_ERROR_00004";
export const USER_DATA_ERROR_RESET_PASSWORD = "USER_AUTH_00005";
